<div class="row">
  <div class="col">
    <el-multi-field
      title="{{ sectionName.label }}"
      placeholder="{{ sectionName.placeholder }}"
      [required]="sectionName.isRequired"
      (onSetValue)="onComplexFieldSetClicked($event)"
      [data]="{
        type: 'ADDRESS',
        value: value,
        fieldConfig: value
      }"
    >
    </el-multi-field>
  </div>
</div>
